































































































































































































































































































































































































































































































































































import Pagination from "@/components/shared/Pagination.vue";
import ShipmentDate from "@/components/shipments/ShipmentsManagement/ShipmentDate.vue";
import ShipmentStatus from "@/components/shipments/ShipmentsManagement/ShipmentStatus.vue";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { isFrance, isUk, translateErrorMessage } from "@/services/Helpers";
import FullScreenModal from "../../shared/modal/FullScreenModal.vue";
import TrackingModal from "./TrackingModal.vue";
import ShipmentsManagementToolbar from "./ShipmentsManagementToolbar.vue";
import MbeLegend from "../../shared/MbeLegend.vue";
import { ShipmentService } from "@/services/ShipmentService";
import {
  PaperlessDocumentDto,
  SearchShipmentDTO,
  ShipmentDTO,
  ShipmentPackageDTO
} from "@/model/data.model";
import {
  GetShipmentResults,
  ShipmentListItem,
  SearchParams,
  ShipmentSearchFilters
} from "@/model/component.model";
import Modal from "../../shared/modal/Modal.vue";
import Filters from "./Filters.vue";
import datetime from "@/filters/DateTimeFilter";
import Accordion from "../../shared/Accordion.vue";
import { AlertBus } from "@/plugins/alerts/AlertBus";
import i18n from "../../../lang/i18n";
import { IPagination } from "@/model/component.model";
import * as moment from "moment";
import { popupFileBase64, alertDangerReason } from "@/services/Helpers";
import PaperlessManagementTable from "@/components/shipments/PaperlessManagementTable.vue";
import WineShipmentsManagementToolbar from "@/components/shipments/ShipmentsManagement/WineShipmentsManagementToolbar.vue";

@Component({
  components: {
    PaperlessManagementTable,
    ShipmentsManagementToolbar: ShipmentsManagementToolbar,
    MbeLegend: MbeLegend,
    Modal: Modal,
    MbeModal: Modal,
    MbeFullScreenModal: FullScreenModal,
    Filters: Filters,
    MbeTrackingModal: TrackingModal,
    Accordion: Accordion,
    ShipmentStatus: ShipmentStatus,
    Pagination: Pagination,
    ShipmentDate: ShipmentDate,
    WineShipmentsManagementToolbar
  }
})
export default class WineShipmentsManagement extends Vue {
  modalTrackingVisible = false;
  modalTrackingOptions = {
    classicon: "invoice-image",
    title: i18n.t("shipment_package_tracking"),
    closeDisabled: true
  };
  selectedShipment: ShipmentDTO = new ShipmentDTO();
  exportOptions: string[] = ["export1", "export2", "export3"];

  shipments: ShipmentListItem[] = [];
  allShipmentsSelected = false;
  filterModalVisible = false;
  showExportExcelModal = false;
  topScrollbarContentWidth = 0;
  exportExcelList: any[] = [];
  searchParams: SearchParams = {
    search: "",
    orderField: "creationDate",
    orderDirection: "desc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };
  searchParamsForArchive: SearchParams = {
    search: "",
    orderField: "creationDate",
    orderDirection: "desc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };
  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };
  paginationForArchive: IPagination = {
    currentPage: 1,
    perPage: 10,
    totalElements: 0,
    perPageOptions: [10]
  };
  selectedTab = "";

  resetFilters() {
    this.searchFilters = Object.assign({}, this.defaultSearchFilters);
  }

  searchHandler(pagination?: IPagination) {
    if (pagination) {
      this.pagination = pagination;
      this.searchParams = Object.assign(this.searchParams, {
        page: pagination.currentPage - 1,
        pageSize: pagination.perPage
      });
    }

    this.search();
  }

  searchHandlerForArchive(pagination: IPagination) {
    this.paginationForArchive = pagination;
    this.searchParamsForArchive.page = pagination.currentPage - 1;
    this.searchParamsForArchive.pageSize = pagination.perPage;
    this.getExportList();
  }
  searchFilters: ShipmentSearchFilters = {} as ShipmentSearchFilters;
  defaultSearchFilters: ShipmentSearchFilters = {
    dateStart: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 30
    ),
    dateEnd: new Date(),
    mbeService: null,
    courier: null,
    courierService: null,
    packageType: null,
    senderCountry: null,
    receiverCountry: null,
    MBETrackingNumber: null,
    CourierTrackingNumber: null,
    reference: null,
    shipmentStatus: ["DRAFT_TO_BE_CLOSED"],
    notStatuses: null,
    delivered: null,
    nameReceiver: null,
    addressReceiver: null,
    cityReceiver: null,
    provinceReceiver: null,
    ZipReceiver: null,
    shipmentId: null,
    hasAttachment: null,
    shipmentDirection: null,
    contactReceiver: null,
    extraServiceFilters: [
      {
        mbeBusinessId: 2,
        value: null
      },
      {
        mbeBusinessId: 3,
        value: null
      },
      {
        mbeBusinessId: 1,
        value: null
      }
    ]
  };
  exportFilters: ShipmentSearchFilters = {
    dateStart: null,
    dateEnd: null,
    mbeService: null,
    courier: null,
    courierService: null,
    packageType: null,
    senderCountry: null,
    receiverCountry: null,
    MBETrackingNumber: null,
    CourierTrackingNumber: null,
    reference: null,
    shipmentStatus: null,
    notStatuses: null,
    delivered: null,
    nameReceiver: null,
    addressReceiver: null,
    cityReceiver: null,
    provinceReceiver: null,
    ZipReceiver: null,
    shipmentId: null,
    hasAttachment: null,
    shipmentDirection: null,
    contactReceiver: null,
    extraServiceFilters: [
      {
        mbeBusinessId: 2,
        value: null
      },
      {
        mbeBusinessId: 3,
        value: null
      },
      {
        mbeBusinessId: 1,
        value: null
      }
    ]
  };
  showPaperlessDocumentsModal = false;

  filterMap = {
    dateStart: {
      title: "start_date",
      value(obj) {
        return moment(obj).format("DD/MM/YYYY");
      }
    },
    dateEnd: {
      title: "end_date",
      value(obj) {
        return moment(obj).format("DD/MM/YYYY");
      }
    },
    mbeService: {
      value(obj) {
        return obj.mbeServiceName;
      }
    },
    courier: {
      value(obj) {
        return obj.courierName;
      }
    },
    courierService: {
      value(obj) {
        return obj.courierServiceName;
      }
    },
    packageType: {
      value(obj) {
        return obj.translatedPackTypeDescription;
      }
    },
    senderCountry: {
      title: "sender_country",
      value(obj) {
        return obj.name;
      }
    },
    receiverCountry: {
      title: "receiver_country",
      value(obj) {
        return obj.name;
      }
    },
    MBETrackingNumber: {
      value(obj) {
        return obj;
      }
    },
    shipmentDirection: {
      title: "shipmentType",
      value(obj) {
        return obj;
      }
    },
    CourierTrackingNumber: {
      value(obj) {
        return obj;
      }
    },
    reference: {
      value(obj) {
        return obj;
      }
    },
    nameReceiver: {
      value(obj) {
        return obj;
      }
    },
    addressReceiver: {
      value(obj) {
        return obj;
      }
    },
    cityReceiver: {
      value(obj) {
        return obj;
      }
    },
    provinceReceiver: {
      value(obj) {
        return obj;
      }
    },
    ZipReceiver: {
      value(obj) {
        return obj;
      }
    },
    contactReceiver: {
      value(obj) {
        return obj;
      }
    },
    extraServiceFilters: {
      value(obj) {
        return obj;
      }
    },
    hasAttachment: {
      value(obj) {
        return obj;
      }
    },
    nameSender: {
      value(obj) {
        return obj;
      }
    }
  };

  get selectedFilters() {
    return Object.keys(this.searchFilters).filter(key => {
      return (
        this.searchFilters[key] &&
        key !== "shipmentStatus" &&
        key !== "notStatuses" &&
        key != "delivered"
      );
    });
  }

  get selectedFiltersValues() {
    let filters = "";
    this.selectedFilters.forEach(filter => {
      if (filter === "extraServiceFilters") {
        if (
          this.searchFilters.extraServiceFilters.some(
            value => value.value !== null
          )
        ) {
          filters += `${this.$t("extra_services")}: `;
          this.searchFilters.extraServiceFilters
            .filter(value => value.value !== null)
            .forEach(filterExtrasvc => {
              filters +=
                this.$t("extraService_" + filterExtrasvc.mbeBusinessId) +
                " " +
                this.$t(filterExtrasvc.value) +
                " ";
            });
          filters += ", ";
        }
      } else {
        filters += this.filterMap[filter].title
          ? `${this.$t(this.filterMap[filter].title)}: `
          : "";
        filters += `${this.filterMap[filter].value(
          this.searchFilters[filter]
        )}, `;
      }
    });
    return filters.substring(0, filters.length - 2);
  }

  applyFilters() {
    this.filterModalVisible = false;
    this.searchParams.page = 0;
    this.search();
  }

  changeTab(event: string) {
    this.selectedTab = event;
  }

  selectOrderFieldAndDirection(orderField: string) {
    if (this.searchParams.orderField === orderField) {
      if (this.searchParams.orderDirection === "asc") {
        this.searchParams.orderDirection = "desc";
      } else {
        this.searchParams.orderDirection = "asc";
      }
    } else {
      this.searchParams.orderField = orderField;
      this.searchParams.orderDirection = "desc";
    }

    this.search();
  }

  getExceptionClass(shipment) {
    if (shipment.courierName === "SDA") {
      if (
        shipment.shipmentPackages.some(
          pack =>
            pack.trackingLastStatusCourier === "020" ||
            pack.trackingLastStatusCourier === "045" ||
            pack.trackingLastStatusCourier === "046" ||
            pack.trackingLastStatusCourier === "047" ||
            pack.trackingLastStatusCourier === "090" ||
            pack.trackingLastStatusCourier === "8BI" ||
            pack.trackingLastStatusCourier === "8CH" ||
            pack.trackingLastStatusCourier === "8CM" ||
            pack.trackingLastStatusCourier === "8DK" ||
            pack.trackingLastStatusCourier === "8DZ" ||
            pack.trackingLastStatusCourier === "8EE" ||
            pack.trackingLastStatusCourier === "8XW" ||
            pack.trackingLastStatusCourier === "8XX" ||
            pack.trackingLastStatusCourier === "E22" ||
            pack.trackingLastStatusCourier === "E46" ||
            pack.trackingLastStatusCourier === "GCP" ||
            pack.trackingLastStatusCourier === "HUB" ||
            pack.trackingLastStatusCourier === "RES" ||
            pack.trackingLastStatusCourier === "RRR" ||
            pack.trackingLastStatusMbeId === 5
        )
      )
        return "red";
    }
    if (!shipment.exception) {
      return "green";
    }

    if (shipment.courierName === "Nexive") {
      return shipment.shipmentPackages.some(
        pack =>
          pack.trackingLastStatusCourier === "33" ||
          pack.trackingLastStatusCourier === "34"
      )
        ? "red"
        : "yellow";
    }
    return "yellow";
  }

  get showSelectOptions() {
    return this.includeHasIncidentColumn;
  }

  get canOpenIncident() {
    return this.$store.getters["customer/claimConfig"].canOpenIncidents;
  }

  get includeHasIncidentColumn() {
    return (
      [
        "shipment_status_in_transit",
        "shipment_status_delivered",
        "all"
      ].includes(this.selectedTab) && this.canOpenIncident
    );
  }

  created() {
    this.resetFilters();
    this.handleSearch("");
  }

  selectItem(item: ShipmentListItem) {
    item.selected = !item.selected;
  }

  selectAll(value: boolean) {
    this.allShipmentsSelected = value;
    this.shipments.forEach((shipment: ShipmentListItem) => {
      shipment.selected = value;
    });
  }

  shipmentsSelected(): ShipmentListItem[] {
    return this.shipments.filter(
      (shipment: ShipmentListItem) => shipment.selected
    );
  }

  getExternalRefText(shipment: any) {
    if (shipment.ecommerceType) {
      if (shipment.elinkReturn) {
        return "elink_return";
      } else {
        return shipment.ecommerceType.toLowerCase();
      }
    }

    return "";
  }

  deleteShipment() {
    if (this.shipmentsSelected().length > 0) {
      const len = this.shipmentsSelected().length;
      AlertBus.$alerts
        .confirm(this.$t("confirm_delete_shipment"))
        .then((val: boolean) => {
          if (val) {
            this.shipmentsSelected().forEach((ship, i) => {
              const shipmentId = ship.shipmentId;
              ShipmentService.deleteShipment(shipmentId)
                .then(res => {
                  this.$snotify.success(
                    this.$t("notification_shipment_deleted").toString(),
                    {
                      timeout: 5000
                    }
                  );
                  if (i == len - 1) this.search();
                })
                .catch(reason => {
                  const err = reason.response.data;
                  if (err.code === "OPERATION_NOT_ALLOWED") {
                    this.$snotify.error(
                      String(
                        this.$t("notification_shipment_can_not_be_deleted")
                      ),
                      {
                        timeout: 5000
                      }
                    );
                    if (len != 1 && i == len - 1) this.search();
                  } else {
                    this.$snotify.error(
                      translateErrorMessage(reason),
                      String(
                        this.$t("notification_shipment_can_not_be_deleted")
                      ),
                      {
                        timeout: 5000
                      }
                    );
                    if (len != 1 && i == len - 1) this.search();
                  }
                });
            });
          }
        });
    }
  }

  editShipment(shipment: ShipmentDTO, event: any) {
    const query = {
      type: "wine"
    };
    if (event.target.classList.contains("status")) return;
    if (shipment.status !== "FIRST_DRAFT_TO_BE_CLOSED") {
      this.$router.push(
        {
          name: "EditShipment",
          params: { id: shipment.shipmentId, isByShipMngm: "1" },
          query
        },
        () => {},
        () => {
          this.$snotify.error("Shipment not found");
        }
      );
    } else {
      this.$router.push(
        {
          name: "NewShipment",
          params: { id: shipment.shipmentId, draft: "draft" },
          query
        },
        () => {},
        () => {
          this.$snotify.error("Shipment not found");
        }
      );
    }
  }

  duplicate(shipment: ShipmentDTO) {
    let query = {};
    if (shipment.shipmentDirection === "INBOUND") {
      query = {
        type: "inbound"
      };
    }
    this.$router.push(
      {
        name: "NewShipment",
        params: { id: shipment.shipmentId, duplicate: "duplicate" },
        query
      },
      () => {},
      () => {
        this.$snotify.error("Shipment not found");
      }
    );
  }

  getTrackingStatus(shipmentPackages: ShipmentPackageDTO[], shipment: any) {
    if (shipmentPackages !== null) {
      let shipmentDelivered = true;
      shipmentPackages.map((shipmentPackage: ShipmentPackageDTO) => {
        if (shipmentPackage.delivered !== true) {
          shipmentDelivered = false;
        }
      });
      if (shipmentDelivered && shipment.courierName === "SDA") {
        if (
          shipment.shipmentPackages.some(
            pack => pack.trackingLastStatusMbeId === 5
          )
        ) {
          return false;
        }
      }
      return shipmentDelivered;
    } else {
      return false;
    }
  }

  hasDeliveredException(shipmentPackages: ShipmentPackageDTO[], shipment: any) {
    if (shipmentPackages !== null) {
      let shipmentDelivered = true;
      shipmentPackages.map((shipmentPackage: ShipmentPackageDTO) => {
        if (shipmentPackage.delivered !== true) {
          shipmentDelivered = false;
        }
      });
      if (shipmentDelivered && shipment.courierName === "SDA") {
        if (
          shipment.shipmentPackages.some(
            pack => pack.trackingLastStatusMbeId === 5
          )
        ) {
          return true;
        }
      }
    }
    return false;
  }

  isTrackingAvailable(shipment: ShipmentListItem) {
    return (
      shipment.status !== "DRAFT_TO_BE_CLOSED" &&
      shipment.status !== "DRAFT_NO_WAYBILL"
    );
  }

  showTrackingModal(shipment: ShipmentListItem, e: any) {
    ShipmentService.getShipment(shipment.shipmentId).then(shipmentDetail => {
      if (
        shipmentDetail.shipmentTrackingNumber != "" &&
        shipmentDetail.shipmentTrackingNumber != null
      ) {
        this.selectedShipment = shipmentDetail;
        this.modalTrackingVisible = true;
      } else {
        return;
      }
    });
  }

  doShipmentClosure(action: string) {
    ShipmentService.closeShipments(this.shipmentsSelected())
      .then((res: ShipmentListItem[]) => {
        this.search();
        this.$snotify.success("Shipments have been closed.");
        ShipmentService.printManifests(res, action)
          .then((data: any[]) =>
            data.forEach((fileBase64: any) => {
              popupFileBase64(fileBase64, "PDF", "PrintManifest.pdf", this);
            })
          )
          .catch(err => {
            this.$snotify.error("It's not possible to show the manifest.");
          });
      })
      .catch(err => {
        const errorMessage = err.response.data.code
          ? i18n.t(err.response.data.code).toString()
          : err.response.data.message;
        this.$snotify.error(errorMessage);
      });
  }

  @Watch("searchParams.search")
  search(searchButton?) {
    // Ensure that selectAll radio checkbox is deselected
    this.selectAll(false);
    this.shipments = [];
    //search all
    if (searchButton) {
      this.searchParams.page = 0;
      this.pagination.currentPage = 1;
      this.selectedTab = "all";
      if (this.$refs.shipmentStatus) {
        (this.$refs.shipmentStatus as ShipmentStatus).nameSelected = "all";
      }
      this.searchFilters.shipmentStatus = null;
      this.searchFilters.delivered = null;
      // this.searchFilters.notStatuses = ["OFFER"];
    }
    const copiedSearchFilters = Object.assign({}, this.searchFilters);
    copiedSearchFilters.dateEnd.setHours(23);
    copiedSearchFilters.dateEnd.setMinutes(59);
    copiedSearchFilters.dateEnd.setSeconds(59);

    ShipmentService.getWineShipments(
      this.$store.getters["customer/info"].customerId,
      this.searchParams,
      copiedSearchFilters,
      this.selectedTab
    )
      .then((res: GetShipmentResults) => {
        res.shipments.forEach((item: SearchShipmentDTO) => {
          const o: ShipmentListItem = { ...(item as ShipmentListItem) };
          o.selected = false;
          this.shipments.push(o);
        });
        this.pagination.totalElements = res.searchParams.totalElements;
        this.searchParams.totalElements = res.searchParams.totalElements;
        this.searchParams.totalPages = res.searchParams.totalPages;
        this.searchParams.numberOfElements = res.searchParams.numberOfElements;
        this.searchParams.page = res.searchParams.page;
        this.searchParams.pageSize = res.searchParams.pageSize;

        this.$nextTick(() => {
          this.topScrollbarContentWidth =
            (this.$refs.table as HTMLElement).offsetWidth || 0;
        });
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }

  @Watch("searchParams.sort") changeSortField() {
    this.search();
  }

  @Watch("searchParams.direction") changeSortDirection() {
    this.search();
  }

  printMBEWaybill() {
    const shipment_ids = this.shipmentsSelected().map(item => item.shipmentId);
    const language = this.$store.getters["customer/config"].language;
    const thermicConfig = this.$store.getters["customer/thermicConfig"];
    const mbeWaybillConfig = thermicConfig.find((el: any) => el.courierId == 0);
    const thermicPrint = mbeWaybillConfig
      ? mbeWaybillConfig.printThermicFormat
      : false;
    const format = thermicPrint ? "f4x6" : "fA4"; // fA4, f4x6, f4x8, f5x9

    if (shipment_ids.length > 1) {
      ShipmentService.printMultipleMBEWaybill(shipment_ids, language, format)
        .then(res => {
          if (res.length === 0) {
            this.$snotify.warning("No MBE waybills");
          } else {
            res.forEach((url: string) => {
              window.open(url, "_blank");
            });
          }
        })
        .catch(err =>
          this.$snotify.error("Error retrieving shipment/s waybill")
        );
    } else {
      ShipmentService.printMBEWaybill(shipment_ids, language, format)
        .then(res => {
          if (res.length === 0) {
            this.$snotify.warning("No MBE waybills");
          } else {
            res.forEach((base64document: string) => {
              popupFileBase64(
                base64document,
                "PDF",
                "Print MBE Waybill" + ".pdf",
                this
              );
            });
          }
        })
        .catch(err =>
          this.$snotify.error("Error retrieving shipment/s waybill")
        );
    }
  }

  printDetailedMBEManifest() {
    const shipments = this.shipmentsSelected();
    if (shipments.length === 0) return;
    ShipmentService.printManifests(shipments, "PRINT_DETAILED_MANIFEST")
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning(this.$t("notification_no_manifests"));
        } else {
          res.forEach((base64document: string) => {
            popupFileBase64(
              base64document,
              "PDF",
              "Print MBE Detailed Manifest" + ".pdf",
              this
            );
          });
        }
      })
      .catch(err =>
        this.$snotify.error(
          this.$t("notification_error_getting_manifests").toString()
        )
      );
  }

  printMBEManifest() {
    const shipments = this.shipmentsSelected();
    if (shipments.length === 0) return;
    ShipmentService.printManifests(shipments, "PRINT_SIMPLIFIED_MANIFEST")
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning(this.$t("notification_no_manifests"));
        } else {
          res.forEach((base64document: string) => {
            popupFileBase64(
              base64document,
              "PDF",
              "Print MBE Manifest" + ".pdf",
              this
            );
          });
        }
      })
      .catch(err =>
        this.$snotify.error(
          this.$t("notification_error_getting_manifests").toString()
        )
      );
  }

  printWaybill() {
    if (this.shipmentsSelected().length > 1) {
      const shipment_ids = this.shipmentsSelected().map(
        item => item.shipmentId
      );
      ShipmentService.getMultipleWaybillsSignedURLs(shipment_ids)
        .then(res => {
          if (res.length === 0) {
            this.$snotify.warning(
              this.$t("notification_no_waybills").toString()
            );
          } else {
            res.forEach((url: string) => {
              window.open(url, "_blank");
            });
          }
        })
        .catch(err => this.$snotify.error("Error retrieving shipment Waybill"));
    } else {
      this.shipmentsSelected().forEach(shipment => {
        ShipmentService.getWaybillsSignedURLs(shipment.shipmentId)
          .then(res => {
            if (res.length === 0) {
              this.$snotify.warning(
                this.$t("notification_no_waybills").toString()
              );
            } else {
              res.forEach((url: string) => {
                window.open(url, "_blank");
              });
            }
          })
          .catch(err =>
            this.$snotify.error("Error retrieving shipment Waybill")
          );
      });
    }
  }

  printCourierManifest() {
    const shipments = this.shipmentsSelected();
    if (shipments.length === 0) return;
    ShipmentService.printManifests(
      shipments,
      "PRINT_DETAILED_MANIFEST",
      shipments[0].courierId,
      shipments[0].courierName
    )
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning(
            this.$t("notification_no_manifests").toString()
          );
        } else {
          res.forEach((base64document: string) => {
            popupFileBase64(
              base64document,
              "PDF",
              "Print Courier Manifest" + ".pdf",
              this
            );
          });
        }
      })
      .catch(err =>
        this.$snotify.error(
          this.$t("notification_error_getting_manifests").toString()
        )
      );
  }

  tableScrolling($event: any) {
    (this.$refs.topScrollbar as HTMLElement).scrollLeft =
      $event?.target?.scrollLeft || 0;
  }

  topScrolling($event: any) {
    (this.$refs.tablecontainer as HTMLElement).scrollLeft =
      $event.target.scrollLeft;
  }

  handleSearch(search: any) {
    if (search === "") {
      ShipmentService.queryMetadataCurrentUser(10, 0, null, "").then(
        (res: any) => {
          this.exportOptions = [];
          for (let i = 0; i < res.content.length; i++) {
            this.exportOptions.push(
              res.content[i].context.substring(10, res.content[i].length)
            );
          }
        }
      );
    }
    if (search === undefined || search.length < 3) {
      return;
    }
    const searchInput = search.toLowerCase();

    ShipmentService.queryMetadataCurrentUser(25, 0, null, searchInput).then(
      (res: any) => {
        this.exportOptions = [];
        for (let i = 0; i < res.content.length; i++) {
          this.exportOptions.push(
            res.content[i].context.substring(10, res.content[i].length)
          );
        }
      }
    );
  }

  hasIcon(shipment: any) {
    return [
      "UPS",
      "FedEx",
      "TNT",
      "DHL",
      "SDA",
      "SGT",
      "Nexive",
      "DPD"
    ].includes(shipment.courierName);
  }

  get france() {
    return isFrance();
  }

  processDate(dateToProcess: any) {
    return datetime(String(new Date(parseInt(dateToProcess))));
  }

  processName(nameToProcess: string) {
    const nameProcessed = nameToProcess.substr(
      nameToProcess.lastIndexOf("/") + 1
    );
    return nameProcessed;
  }

  toggleExportExcelListModal() {
    this.paginationForArchive.currentPage = 1;
    this.showExportExcelModal = !this.showExportExcelModal;
  }

  generateExportST(item?: any) {
    const searchcomponent: any = this.$refs.searchcomponent as any;
    const shipments = this.shipmentsSelected();
    this.exportFilters.shipmentId = [];
    shipments.forEach(ship => {
      this.exportFilters.shipmentId.push(ship.shipmentId);
    });

    let filters;
    if (this.shipmentsSelected().length === 0) {
      filters = this.searchFilters;
    } else {
      filters = this.exportFilters;
    }

    let context = "shipments-management-mol";
    if (item) context = "shipments-" + item;
    ShipmentService.generateExportShipTrace(
      this.$store.getters["customer/info"].customerId,
      this.searchParams,
      filters,
      context,
      true
    )
      .then((res: any) => {
        this.$notify.success(String(this.$t("exporting")));
        return res.data;
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  getExportList() {
    this.showExportExcelModal = true;
    ShipmentService.getExportList(
      null,
      this.paginationForArchive.perPage,
      this.paginationForArchive.currentPage - 1
    )
      .then((res: any) => {
        this.exportExcelList = res.content;
        this.paginationForArchive.totalElements = res.totalElements;
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  getDownloadableLink(filePath: string) {
    ShipmentService.getPreSignedShipmentDocumentURL(filePath)
      .then((res: any) => {
        const link: string = res;
        const a: any = document.createElement("A");
        const openNewTab = (file: string) => {
          const filePath: any = file;
          a.href = filePath;
          a.setAttribute("target", "_blank");
          a.download = filePath.substr(filePath.lastIndexOf("/") + 1);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        openNewTab(link);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  datesChangeHandler(event: any) {
    Vue.set(this.searchFilters, "dateStart", event.dateStart);
    Vue.set(this.searchFilters, "dateEnd", event.dateEnd);

    if (isFrance()) {
      this.search(true);
    }
  }

  get dates() {
    if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
      return false;
    } else {
      return true;
    }
  }

  get uk() {
    return isUk();
  }
}
